export enum HotelImageActionTypeEnum {
  SEEN = 'seen',
  SWIPE = 'swipe',
  SWIPE_BACK = 'swipe_back',
  CLICK = 'click',
}
